export default "__VITE_ASSET__CRhGMEW___"